import { useMutation } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { handleResponse } from "@/utils/errorResponseHandlers";

export interface SocialAuthorizeRequest {
  provider: string;
  redirect_uri: string;
}

export interface SocialAuthorizeResponse {
  success: boolean;
  authorization_url: string;
  state: string;
}

export const useSocialAuthorize = (params?: SocialAuthorizeRequest) => {
  const url = new URL(ENDPOINTS.auth.social_authorize);

  if (params?.provider) {
    url.searchParams.set("provider", params.provider);
  }
  if (params?.redirect_uri) {
    url.searchParams.set("redirect_uri", params.redirect_uri);
  }

  return useMutation<SocialAuthorizeResponse>({
    mutationFn: async (): Promise<SocialAuthorizeResponse> =>
      fetch(url.toString(), {
        method: "GET",
      }).then(handleResponse),
    onSuccess: ({ authorization_url }) => {
      window.location.href = authorization_url;
    },
  });
};
